'use client';

import { useCallback, useState } from 'react';

interface UseMultiStepFormProps {
  totalSteps: number;
}

export function useMultiStepForm({ totalSteps }: UseMultiStepFormProps) {
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState<Record<string, unknown>>({});

  const nextStep = useCallback(
    (stepData: Record<string, unknown>) => {
      setFormData((prev) => ({ ...prev, ...stepData }));
      setStep((prev) => Math.min(prev + 1, totalSteps - 1));
    },
    [totalSteps]
  );

  const prevStep = useCallback(() => {
    setStep((prev) => Math.max(prev - 1, 0));
  }, []);

  const reset = useCallback(() => {
    setStep((currentStep) => (currentStep === 0 ? currentStep : 0));
    setFormData((currentFormData) =>
      Object.keys(currentFormData).length === 0 ? currentFormData : {}
    );
  }, []);

  return {
    step,
    formData,
    nextStep,
    prevStep,
    reset,
    isLastStep: step === totalSteps - 1,
  };
}
